import React from 'react';
import ReactMarkdown from 'react-markdown';
import './MessageBubble.css';

const MessageBubble = ({ message, isUser }) => {
  const formatMessageContent = (content) => {
    if (!content) return '';
    if (typeof content === 'object') {
      return content.text || content.response || '';
    }
    return content;
  };

  return (
    <div className={`message-bubble ${isUser ? 'user' : 'bot'}`}>
      <div className="message-content">
        {!isUser && <div className="bot-avatar">🔧</div>}
        <div className="message-body">
          <div className="message-text">
            <ReactMarkdown>
              {formatMessageContent(message.content)}
            </ReactMarkdown>
          </div>
        </div>
        {isUser && <div className="user-avatar">👤</div>}
      </div>
    </div>
  );
};

export default MessageBubble;